import ActionTypes from './action.types'

const initialState = {
    accounts: [],
    licenseCount: 0,
    signupStep: 0,
    showToast: false,
    signupError: false

}

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_USER:
            return {
                ...state,
                user: action.payload.user
            }
        case ActionTypes.SET_FILENAMES:
            return {
                ...state,
                filenames: action.payload.filenames
            }
        case ActionTypes.SET_PACKAGE_TYPE:
            return {
                ...state,
                packageType: action.payload.packageType
            }
        case ActionTypes.SET_BLOCKED_EMAILS:
            return {
                ...state,
                blockedEmails: action.payload.blockedEmails
            }
        case ActionTypes.SET_SIGNUP_ERROR:
            return {
                ...state,
                signupError: action.payload.signupError
            }
        case ActionTypes.SET_COUPON:
            return {
                ...state,
                coupon: action.payload.coupon
            }
        case ActionTypes.SET_USAGE_TYPE:
            return {
                ...state,
                usageType: action.payload.usageType
            }
        case ActionTypes.SET_STATS:
            return {
                ...state,
                stats: action.payload.stats
            }

        case ActionTypes.SET_SIGNUP_STEP:
            return {
                ...state,
                signupStep: action.payload.step
            }
        case ActionTypes.SET_PHISHING_URLS:
            return {
                ...state,
                phishingUrls: action.payload.phishingUrls
            }

        case ActionTypes.UPDATE_BLOCKED_EMAIL:
            const tempBlocked = [...state.blockedEmails];
            const blockIndex = state.blockedEmails.findIndex(blocked => blocked._id === action.payload.blocked._id);
            tempBlocked[blockIndex] = action.payload.blocked
            return {
                ...state,
                blockedEmails: tempBlocked
            }

        case ActionTypes.UPDATE_PHISHING_URL:
            const tempPhish = [...state.phishingUrls];
            const blockIndexPhish = state.phishingUrls.findIndex(blocked => blocked._id === action.payload.phishingUrl._id);
            tempPhish[blockIndexPhish] = action.payload.phishingUrl
            return {
                ...state,
                phishingUrls: tempPhish
            }
        case ActionTypes.UPDATE_ACCOUNT:
            const tempArr = [...state.accounts];
            const index = state.accounts.findIndex(user => user._id === action.payload.account._id);
            tempArr[index] = action.payload.account
            var licenseCount = 0
            for (const u of tempArr) {
                if (u.devices && u.devices.length > 0) {
                    licenseCount += u.devices?.filter(dev => dev.isActive).length
                }
            }
            if (state.user?.devices) {
                licenseCount += state.user?.devices?.filter(dev => dev.isActive).length
            }
            return {
                ...state,
                accounts: tempArr,
                licenseCount
            }
        case ActionTypes.SET_ACCOUNTS:
            var licenseCount = 0
            for (const u of action.payload.accounts) {
                if (u.devices && u.devices.length > 0) {
                    licenseCount += u.devices?.filter(dev => dev.isActive).length
                }
            }
            if (state.user?.devices) {
                licenseCount += state.user?.devices?.filter(dev => dev.isActive).length
            }
            return {
                ...state,
                accounts: action.payload.accounts,
                licenseCount
            }
        case ActionTypes.UPDATE_DOWN:
            let user = JSON.parse(JSON.stringify(state.user))
            user.downCount++
            return {
                ...state,
                user
            }

        case ActionTypes.UPDATE_PROCESS:
            let stats2 = JSON.parse(JSON.stringify(state.stats))
            stats2.processBlocked++
            return {
                ...state,
                stats: stats2
            }
        case ActionTypes.UPDATE_BLOCKED:
            let stats1 = JSON.parse(JSON.stringify(state.stats))
            stats1.downBlocked++
            return {
                ...state,
                stats: stats1
            }
        case ActionTypes.ADD_USER:
            return {
                ...state,
                accounts: [...state.accounts, action.payload.user]
            }
        case ActionTypes.SET_TOAST:
            return {
                ...state,
                showToast: true,
                toastHeader: action.payload.header,
                toastMsg: action.payload.msg
            }
        case ActionTypes.SET_SELECTED_USER:
            return {
                ...state,
                selectedUser: action.payload.user
            }
        case ActionTypes.CLEAR_TOAST:
            return {
                ...state,
                showToast: false
            }
        default:
            return state
    }
}

export default Reducer